import type {ALIGNMENT_TYPE} from '@Components/dropdown-v2/dropdown.types';
import type {ReactElement} from 'react';
import type {LineCapStyle} from '@PosterWhiteboard/items/line-item/line-item.types';

export const LINE_END_POINT_SIZE = 12;
export const DEFAULT_LINE_HEIGHT = 6;
export const DEFAULT_LINE_WIDTH = 500;
export enum LineCapStyleOptionTypes {
  LINE_START = 'line-start',
  LINE_END = 'line-end',
}

export interface LineCapStyleOptionsPopup {
  dropdownPopup: ReactElement;
  alignment: ALIGNMENT_TYPE;
  id: LineCapStyleOptionTypes;
}

export interface LineCapStyleOption {
  id: LineCapStyle;
}
